<template>
  <div class="duplicate-review-debug">
    <el-card shadow="always" class="debug-card">
      <div class="debug-card__header">
        <span>重复图片审核调试页</span>
        <div>
          <el-button type="text" @click="loadFixture">重新加载假数据</el-button>
          <el-button type="primary" size="mini" @click="openModal">打开弹窗</el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <p class="debug-card__tip">当前假数据：</p>
      <pre class="debug-card__json">{{ fixture }}</pre>
    </el-card>

    <image-compare-modal
      :visible.sync="modalVisible"
      :original-image="originalImage"
      :comparison-images="comparisonImages"
      :on-decision="handleDecision"
      @index-change="handleIndexChange"
      @close="closeModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import fixture from "@/mock/duplicate-review.json";
import ImageCompareModal from "@/components/ImageCompareModal.vue";

export default {
  name: "DuplicateReviewDebug",
  components: { ImageCompareModal },
  data() {
    return {
      modalVisible: false,
      fixture,
    };
  },
  computed: {
    ...mapState("review", ["originalImage", "comparisonImages"]),
  },
  created() {
    this.loadFixture();
  },
  methods: {
    ...mapActions("review", ["loadFromFixture", "setActiveIndex", "submitDecision"]),
    openModal() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    async loadFixture() {
      await this.loadFromFixture(this.fixture);
    },
    handleIndexChange(index) {
      this.setActiveIndex(index);
    },
    handleDecision(originalId, comparisonId, isSame) {
      return this.submitDecision({ isSame, source: "modal" });
    },
  },
};
</script>

<style scoped>
.duplicate-review-debug {
  padding: 24px;
}

.debug-card {
  margin-bottom: 24px;
}

.debug-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.debug-card__tip {
  margin: 8px 0;
  color: #606266;
}

.debug-card__json {
  max-height: 240px;
  overflow: auto;
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
